/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import session from "redux-persist/lib/storage/session";
import ArrowSvg from "../../../../assets/images/arrow-back.svg";
import Layout from "../../../components/Provider/Layout";
import QrScan from "../../../components/Provider/QrScan";
import CustomButton from "../../../components/shared/CustomButton";
import CustomPaper from "../../../components/shared/CustomPaper";
import ListItem from "../../../components/shared/ListItem";
import Loading from "../../../components/shared/Loading";
import {
  default as MessageModal,
  default as SimpleModal,
} from "../../../components/shared/MessageModal";
import ScanButton from "../../../components/shared/ScanButton";
import Search from "../../../components/shared/Search";
import useLocalStorage from "../../../hooks/useLocalStorage";
import {
  default as ProviderService,
  default as ProviderServices,
} from "../../../services/ProviderServices";
import { getLockers, filterLockers } from "../../../utils/helperLockers";
import { validateNumber } from "../../../utils/regexValidator";
import "./Reception.scss";

let getCudsRipley = [];
let getCudsMarketplace = [];
let allLockers = [];
function Reception() {
  const [activeTab, setActiveTab] = useState(0);
  const [cancelWarning, setCancelWarning] = useState(false);
  const [cudsFounded, setCudsFounded] = useState([]);
  const [devolutionCuds, setDevolutionCuds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalErrorCud, setModalErrorCud] = useState(false);
  const [modalInternetError, setModalInternetError] = useState(false);
  const [modalNoInternet, setModalNoInternet] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalSuccessCud, setModalSuccessCud] = useState(false);
  const [processedCuds, setProcessedCuds] = useState([]);
  const [receptionSession, setReceptionSession] =
    useLocalStorage("receptionSession");
  const [scanning, setScanning] = useState(false);
  const [selectedCarton, setSelectedCarton] = useState(null);
  const [selectedCud, setSelectedCud] = useState({ id: "123423-A" });
  const [sessionId, setSession] = useState(null);
  const [sessionWarning, setSessionWarning] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const [signature, setSignature] = useState(null);
  const [textSearch, setTextSearch] = useState("");
  const [ubicationError, setUbicationError] = useState(false);
  const [userappret] = useLocalStorage("userappret");
  const history = useHistory();
  const {
    location: { state },
  } = history;
  useEffect(() => {
    let timer = "";
    if (!userappret.pickupPointId) {
      setUbicationError(true);
      timer = setTimeout(() => {
        history.push("/home");
      }, 2500);
    }
    return () => (timer ? clearTimeout(timer) : null);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const startPage = async () => {
      setLoading(true);
      if (state && state.activeTab) setActiveTab(state.activeTab);
      if (state && state.showModalSuccess) {
        history.replace({
          pathname: "/recepcion",
          state: {},
        });
        setModalSuccess(true);
      }
      await fetchData();
      await fetchData2();
      let sessionId = null;
      if (state && state.sessionId) sessionId = state.sessionId;
      else if (receptionSession) sessionId = receptionSession.sessionId;
      if (sessionId) {
        setActiveTab(receptionSession.activeTab);
        setSession(sessionId);
        await getProcessedCuds(sessionId);
      }
      setLoading(false);
    };
    startPage();
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    try {
      const cuds = await ProviderServices.getCuds(
        userappret.pickupPointId,
        userappret.plate
      );
      setCudsFounded(formatCuds(cuds));

      const beforeSession = await ProviderServices.getBeforeSession(
        userappret.pickupPointId,
        userappret.userId
      );
      if (beforeSession.length > 0) {
        const cudsFormatted = beforeSession.map((c) => ({
          id: c.cudNumber,
          location: c.placeName,
          locationId: c.placeId,
          numProducts: c.quantity,
          guide: c.guideNumber,
          type: c.originType,
          suborder: c.suborder,
          skus: c.ean,
        }));
        setProcessedCuds(cudsFormatted);
        setSession(beforeSession[0].sessionid);
        /* setActiveTab(0) */
        /*  setReceptionSession({ activeTab: 0 }) */
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const fetchData2 = async () => {
    try {
      const cuds = await ProviderServices.getDevolutionCuds(
        userappret.pickupPointId,
        userappret.plate
      );
      setDevolutionCuds(formatCuds(cuds));
    } catch (e) {
      console.log(e);
    }
  };

  const getProcessedCuds = async (sessionId) => {
    try {
      const cuds = await ProviderServices.getSessionStatus(sessionId);
      const cudsFormatted = cuds.map((c) => ({
        id: c.cudNumber,
        location: c.placeName,
        locationId: c.placeId,
        numProducts: c.quantity,
        guide: c.guideNumber,
        type: c.originType,
        suborder: c.suborder,
        skus: c.skus,
      }));
      setProcessedCuds(cudsFormatted);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const formatCuds = (cuds) => {
    return cuds.map((c) => {
      c.id = c.cudNumber;
      c.numProducts = c.quantity;
      c.guide = c.guideNumber;
      c.locationId = c.placeId;
      // eslint-disable-next-line no-self-assign
      c.placeName = c.placeName;
      // eslint-disable-next-line no-self-assign
      c.type = c.originType;
      return c;
    });
  };

  const handleTextChange = (e) => {
    const value = e.target.value;
    // if (validateNumber(value) && value.length <= 22)
    if (value.length <= 22) setTextSearch(value);
  };

  const storeSession = (sessionId) => {
    const { pickupPointId, title } = userappret;
    const receptionSession = {
      sessionId,
      pickupPointId,
      title,
      activeTab,
    };
    setReceptionSession(receptionSession);
    // localStorage.setItem('receptionSession', JSON.stringify(receptionSession))
  };

  const initSession = async () => {
    try {
      setLoading(true);
      const { pickupPointId, userId } = userappret;
      // const uid = `${userId}-${pickupPointId}`

      const sessionId = await ProviderServices.getReceptionSession(
        activeTab === 0 ? "reception" : "return",
        pickupPointId,
        userId
      );
      setSession(sessionId);
      storeSession(sessionId);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
      setModalNoInternet(true);
    }
  };

  const handleCancelSession = async () => {
    setLoading(true);
    const response = await ProviderServices.deleteSession(sessionId);
    localStorage.removeItem("receptionSession");
    setSession(null);
    setProcessedCuds([]);
    setCancelWarning(false);
    // setShowSummary(false);
    await fetchData();
    history.push("/recepcion");
    setLoading(false);
  };

  const handleRipleyCud = ({ cf, sessionId, activeTab }) => {
    return sessionId
      ? history.push(`recepcion/${cf.id}`, {
          cudToProcess: {
            id: cf.id,
            numProducts: cf.numProducts,
            guide: cf.guide,
            locationId: cf.locationId,
            placeName: cf.placeName,
            type: cf.type,
          },
          sessionId,
          activeTab,
        })
      : setSessionWarning(true);
  };

  const handleMarkerplaceCud = ({ cf, sessionId, activeTab }) => {
    sessionId
      ? history.push(`recepcion/${cf.id}`, {
          cudToProcess: {
            id: cf.suborder,
            numProducts: cf.numProducts || 1,
            guide: cf.suborder,
            locationId: cf.locationId,
            placeName: cf.placeName,
            skus: cf.skus,
            type: cf.type,
          },
          sessionId,
          activeTab,
        })
      : setSessionWarning(true);
  };

  const showCuds = () => {
    const filteredData = activeTab === 0 ? cudsFounded : devolutionCuds;

    if (filteredData.length === 0) {
      return (
        <div className="reception-empty">
          <h2>
            No hay más productos por{" "}
            {activeTab === 0 ? "recepcionar" : "devolver"}
          </h2>
          {sessionId && processedCuds.length > 0 && (
            <h3>Para continuar, haz clic en "Finalizar"</h3>
          )}
        </div>
      );
    }

    allLockers = activeTab === 0 ? null : getLockers(filteredData);
    getCudsRipley = filteredData.filter((data) =>
      data.originType.includes("ripley")
    );
    getCudsMarketplace = filteredData.filter((data) =>
      data.originType.includes("mkp")
    );
    return (
      <>
        {activeTab === 0 ? (
          <>
            <ListItem
              img={"./IconListRipley.png"}
              desc={"Productos Ripley"}
              cant={getCudsRipley.length}
            >
              {getCudsRipley.map((cf, i) =>
                cf.id.includes(textSearch) ||
                cf.guide.toString().includes(textSearch) ? (
                  <CustomPaper
                    key={`tile-${cf.id}-${i}`}
                    title={`Guía: ${cf.guide}`}
                    description={`CUD: ${cf.id}`}
                    quantity={<div>x {cf.numProducts}</div>}
                    enable={sessionId}
                    onClick={() =>
                      handleRipleyCud({ cf, sessionId, activeTab })
                    }
                  />
                ) : null
              )}
            </ListItem>
            <ListItem
              img={"./IconListMarketplace.png"}
              desc={"Marketplace"}
              cant={getCudsMarketplace.length}
            >
              {getCudsMarketplace.map((cf, i) =>
                cf.guide.includes(textSearch) ||
                cf.suborder.toString().includes(textSearch) ||
                cf.skus.find((sku) => sku.sku.includes(textSearch)) ? (
                  <CustomPaper
                    key={`tile-${cf.skus.sku}-${i}`}
                    title={<div>OC: {cf.suborder}</div>}
                    description={cf.skus.map((sku) => {
                      return <div key={sku.sku}>SKU: {sku.sku}</div>;
                    })}
                    quantity={cf.skus.map((sku) => {
                      return <div key={sku.sku}>x{sku.quantity}</div>;
                    })}
                    enable={sessionId}
                    onClick={() =>
                      handleMarkerplaceCud({ cf, sessionId, activeTab })
                    }
                  />
                ) : null
              )}
            </ListItem>
          </>
        ) : (
          <>
            {allLockers.map((locker, i) => (
              <ListItem
                desc={locker}
                cant={
                  filteredData.filter((data) => data.placeName === locker)
                    .length
                }
                img={null}
                key={i}
              >
                {filterLockers(filteredData, "ripley", locker).length > 0 && (
                  <ListItem
                    img={"./IconListRipley.png"}
                    desc={"Productos Ripley"}
                    cant={filterLockers(filteredData, "ripley", locker).length}
                  >
                    {filterLockers(filteredData, "ripley", locker).map(
                      (cf, i) =>
                        cf.id.includes(textSearch) ||
                        cf.guide.toString().includes(textSearch) ? (
                          <CustomPaper
                            key={`tile-${cf.id}-${i}`}
                            title={<div>Guía: {cf.guide}</div>}
                            description={<div>CUD: {cf.id}</div>}
                            quantity={<div>x {cf.numProducts}</div>}
                            enable={sessionId}
                            onClick={() =>
                              handleRipleyCud({ cf, sessionId, activeTab })
                            }
                          />
                        ) : null
                    )}
                  </ListItem>
                )}
                {filterLockers(filteredData, "mkp", locker).length > 0 && (
                  <ListItem
                    img={"./IconListMarketplace.png"}
                    desc={"Marketplace"}
                    cant={filterLockers(filteredData, "mkp", locker).length}
                  >
                    {filterLockers(filteredData, "mkp", locker).map((cf, i) =>
                      cf.guide.includes(textSearch) ||
                      cf.suborder.toString().includes(textSearch) ||
                      cf.skus.find((sku) => sku.sku.includes(textSearch)) ? (
                        <CustomPaper
                          key={`tile-${cf.skus.sku}-${i}`}
                          title={<div>OC: {cf.suborder}</div>}
                          description={cf.skus.map((sku) => {
                            return <div key={sku.sku}>SKU: {sku.sku}</div>;
                          })}
                          quantity={cf.skus.map((sku) => {
                            return <div key={sku.sku}>x{sku.quantity}</div>;
                          })}
                          enable={sessionId}
                          onClick={() =>
                            handleMarkerplaceCud({ cf, sessionId, activeTab })
                          }
                        />
                      ) : null
                    )}
                  </ListItem>
                )}
              </ListItem>
            ))}
          </>
        )}
      </>
    );
  };

  const getDisabled = () => {
    if (activeTab === 0) {
      if (cudsFounded.length === 0) return true;
    } else {
      if (devolutionCuds.length === 0) return true;
    }
    return false;
  };

  // const handleScan = async scanResult => {
  //   setScanning(false)
  //   const carton = scanResult || selectedCarton
  //   try {
  //     setLoading(true)
  //     const cud = await ProviderService.getCudByCarton(carton)
  //     const listedCud = activeTab ? devolutionCuds.find(c => c.id === cud) : cudsFounded.find(c => c.id === cud)
  //     setSelectedCud(listedCud || { id: cud })
  //     setLoading(false)
  //     if (listedCud) {
  //       setModalSuccessCud(true)
  //     }
  //     else setModalErrorCud(true)
  //   } catch (e) {
  //     console.log('error: ', e)
  //     setLoading(false)
  //     setSelectedCarton(carton)
  //     setModalInternetError(true)
  //   }
  // }

  const handleScan = (scanResult) => {
    async function handle() {
      setScanning(false);
      const textSearch = scanResult || selectedCarton;
      try {
        const matchRipleyCuds = getCudsRipley.filter((cf) =>
          cf.id.includes(`${textSearch}`)
        );
        const matchMarketplaceCuds = getCudsMarketplace.filter(
          (cf) =>
            cf.id.includes(`${textSearch}`) ||
            cf.suborder.includes(`${textSearch}`)
        );

        console.log({
          scanResult,
          textSearch,
          matchRipleyCuds,
          matchMarketplaceCuds,
        });

        if (matchRipleyCuds.length > 0) {
          console.log("CASE 1");
          const cf = matchRipleyCuds[0];
          handleRipleyCud({ cf, sessionId, activeTab });
        } else if (matchMarketplaceCuds.length > 0) {
          console.log("CASE 2");
          const cf = matchMarketplaceCuds[0];
          handleMarkerplaceCud({ cf, sessionId, activeTab });
        } else {
          console.log("CASE 3");
          setLoading(true);
          const cud = await ProviderService.getCudByCarton(textSearch);
          console.log("CudOfCarton", cud);
          setLoading(false);
          handleRipleyCud({ cud, sessionId, activeTab });
        }
      } catch (e) {
        console.log("error: ", e);
        setLoading(false);
        // setSelectedCarton(carton)
        setModalInternetError(true);
      }
    }
    handle();
  };

  const checkScanDisabled = () => {
    if (!sessionId) return false;
    const filteredData = activeTab === 0 ? cudsFounded : devolutionCuds;
    if (filteredData.length === 0) return false;
    return true;
  };

  return !scanning ? (
    <Layout>
      <Loading visible={loading} />
      <MessageModal
        visible={modalNoInternet}
        closeModal={() => setModalNoInternet(false)}
        message="No tiene conexión a internet"
        type={2}
      />
      <MessageModal
        visible={modalErrorCud}
        closeModal={() => {
          setModalErrorCud(false);
        }}
        type={12}
        title={
          selectedCud.id.includes("-") ? "OC no listada" : "CUD no listado"
        }
        txtBtn1="ESCANEAR DE NUEVO"
        onClickBtn1={() => {
          setModalErrorCud(false);
          setScanning(true);
        }}
        txtBtn2="REGRESAR A LA LISTA"
        onClickBtn2={() => {
          setModalErrorCud(false);
          setScanning(false);
        }}
        inlineButtons
      >
        <div className="modal-warning-message">
          <p>
            {selectedCud.id.includes("-") ? "el sub-pedido" : "el código CUD"}
            <br />
            <span>{selectedCud.id}</span>
            <br />
            no aparece en la lista
          </p>
        </div>
      </MessageModal>
      <MessageModal
        visible={modalInternetError}
        closeModal={() => setModalInternetError(false)}
        type={24}
        title="No hay conexión"
        message="Revisa tu conexión a internet e inténtalo de nuevo"
        txtBtn1="VOLVER"
        onClickBtn1={() => {
          setModalInternetError(false);
        }}
        txtBtn2="REINTENTAR"
        onClickBtn2={() => {
          setModalInternetError(false);
          handleScan();
        }}
      />
      <MessageModal
        visible={modalSuccessCud}
        closeModal={() => setModalSuccessCud(false)}
        type={13}
        title="Verificar el código CUD"
        txtBtn2="CONTINUAR"
        onClickBtn2={() => {
          setModalSuccessCud(false);
          history.push(`recepcion/${selectedCud.id}`, {
            cudToProcess: {
              id: selectedCud.id,
              numProducts: selectedCud.numProducts,
              guide: selectedCud.guide,
              locationId: selectedCud.locationId,
              placeName: selectedCud.placeName,
            },
            sessionId,
            activeTab,
          });
        }}
        inlineButtons
      >
        <div className="modal-warning-message">
          <p>
            Se ha escaneado el CUD
            <br />
            <span>{selectedCud && selectedCud.id}</span>
          </p>
        </div>
      </MessageModal>

      <SimpleModal
        visible={ubicationError}
        // closeModal={() => setUbicationError(false)}
        message="No tiene una ubicación asignada, elija una o pida que se le asigne una"
        type={1}
      />
      <SimpleModal
        visible={sessionWarning}
        closeModal={() => setSessionWarning(false)}
        message="Debe darle en iniciar para poder recepcionar"
        type={1}
        txtBtn1="Ok"
        onClickBtn1={() => setSessionWarning(false)}
      />
      <SimpleModal
        visible={cancelWarning}
        txtBtn1="SALIR"
        onClickBtn1={handleCancelSession}
        txtBtn2={"CONTINUAR"}
        onClickBtn2={() => {
          setCancelWarning(false);
        }}
        type={10}
        closeModal={() => setCancelWarning(false)}
        title={"¿Seguro que deseas cancelar?"}
      >
        <div className="modal-warning-message">
          <p>
            Los cambios <span>no serán guardados</span> y el proceso de{" "}
            {activeTab === 0 ? "despacho" : "devolución"} finalizará.
          </p>
        </div>
      </SimpleModal>
      <SimpleModal
        visible={modalSuccess}
        title={
          (activeTab === 0 ? "Recepción" : "Devolución") +
          " realizada con éxito"
        }
        txtBtn2="ACEPTAR"
        onClickBtn2={() => {
          setModalSuccess(false);
        }}
        type={11}
        closeModal={() => setModalSuccess(false)}
      >
        <div className="modal-success-message">
          <p>
            Se realizó la
            <span>{activeTab === 0 ? "recepción" : "devolución"}</span> para
          </p>
          <h2>{userappret.title}</h2>
          <img src={userappret.operatorImage} />
        </div>
      </SimpleModal>
      <div className="reception-container">
        <div className="reception-header">
          {sessionId ? (
            <img
              src={ArrowSvg}
              alt="atras"
              onClick={sessionId ? () => setCancelWarning(true) : initSession}
            />
          ) : (
            <Link
              to={{
                pathname: "/home",
                state: {
                  plate: userappret.plate,
                  operator: userappret.operator,
                  from: "recepcion",
                },
              }}
              style={{ display: "flex" }}
            >
              <img src={ArrowSvg} alt="atras" />
            </Link>
          )}

          <h3>{userappret.title}</h3>
        </div>
        <div className="reception-tabs">
          <div
            className={!activeTab && "active"}
            onClick={() => (sessionId ? null : setActiveTab(0))}
          >
            Recepción ({cudsFounded.length})
          </div>
          <div
            className={activeTab && "active"}
            onClick={() => (sessionId ? null : setActiveTab(1))}
          >
            Devolución ({devolutionCuds.length})
          </div>
        </div>
        <div className="reception-search-container">
          <Search
            text={textSearch}
            setText={handleTextChange}
            placeholder="GUÍA, CUD, OC o SKU"
          />
          <ScanButton
            active={checkScanDisabled()}
            onPress={() => setScanning(true)}
          />
        </div>
        <div className="reception-paper-container">{showCuds()}</div>
        <div className="reception-footer">
          {processedCuds.length <= 0 ? (
            sessionId ? (
              <>
                <CustomButton
                  filled
                  margin="20px 0 20px 20px"
                  cancel={sessionId}
                  onClick={
                    sessionId ? () => setCancelWarning(true) : initSession
                  }
                >
                  CANCELAR
                </CustomButton>
                <CustomButton
                  margin="20px 20px 20px 0"
                  onClick={() => {
                    history.push(`recepcion/resumen`, {
                      processedCuds,
                      sessionId,
                      activeTab,
                    });
                    // setShowSummary(true)
                  }}
                  disabled={processedCuds.length <= 0}
                >
                  FINALIZAR
                </CustomButton>
              </>
            ) : (
              <CustomButton
                size="small"
                filled
                width="100%"
                margin="24px"
                disabled={getDisabled()}
                cancel={sessionId}
                onClick={sessionId ? () => setCancelWarning(true) : initSession}
              >
                INICIAR
              </CustomButton>
            )
          ) : (
            <>
              <CustomButton
                filled
                margin="24px 0 24px 24px"
                cancel={sessionId}
                onClick={sessionId ? () => setCancelWarning(true) : initSession}
              >
                CANCELAR
              </CustomButton>
              <CustomButton
                margin="24px 24px 24px 0"
                onClick={() => {
                  history.push(`recepcion/resumen`, {
                    processedCuds,
                    sessionId,
                    activeTab,
                  });
                  // setShowSummary(true)
                }}
                disabled={processedCuds.length <= 0}
              >
                FINALIZAR
              </CustomButton>
            </>
          )}
        </div>
      </div>
      {/* <Summary
        processedCuds={processedCuds}
        showSummary={showSummary}
        activeTab={activeTab}
        onClickCancel={() => setCancelWarning(true)}
        handleSignature={handleSignature}
        goBack={() => setShowSummary(false)}
      /> */}
    </Layout>
  ) : (
    <QrScan
      handleScan={handleScan}
      onClose={() => setScanning(false)}
      barcode
      title="Escaneo de cartón"
      subtitle="Escanea el código de barras ubicado en la etiqueta del cartón."
    />
  );
}

export default Reception;
